export default {
  buttons: {
    next: "Suivant",
    prev: "Retour",
    skip: "Passer",
    done: "Terminé",
    gotIt: "Compris",
  },
  messages: {
    dontShowAgainLabel: "Ne plus afficher ceci",
    stepNumbersOfLabel: "sur",
  },
};
